import {
  TaskCategory,
  TaskCategoryTaskType,
  TaskCategoryWorkflowType,
} from '@urbanx/agx.activities.client'
import {
  IconTaskType,
  IconTaskTypes,
  SelectChipOption,
} from '@urbanx/agx.ui-components2'

const taskIconMap: Partial<Record<TaskCategoryTaskType, IconTaskType>> = {
  [TaskCategoryTaskType.NewListing]: IconTaskTypes.NewListing,
  [TaskCategoryTaskType.GeneralContractCompliance]: IconTaskTypes.AgreementCompliance,
  [TaskCategoryTaskType.Settlement]: IconTaskTypes.Settlement,
  [TaskCategoryTaskType.SettlementPaymentsReview]: IconTaskTypes.Settlement,
  [TaskCategoryTaskType.SettlementPayments]: IconTaskTypes.ApproveSettlementTransfers,
  [TaskCategoryTaskType.Termination]: IconTaskTypes.Terminate,
  [TaskCategoryTaskType.TerminationPaymentsReview]: IconTaskTypes.Terminate,
  [TaskCategoryTaskType.Withdrawn]: IconTaskTypes.Withdrawn,
  [TaskCategoryTaskType.TenancyInformation]: IconTaskTypes.Tenanted,
  [TaskCategoryTaskType.SellerDisclosureUpload]: IconTaskTypes.SellerDisclosure,
  [TaskCategoryTaskType.HolidayRental]: IconTaskTypes.HolidayRental,
  [TaskCategoryTaskType.OwnerBuilderDeclarationUpload]: IconTaskTypes.OwnerBuilder,
  [TaskCategoryTaskType.Launch]: IconTaskTypes.Launch,
  [TaskCategoryTaskType.CoolingOffPeriod]: IconTaskTypes.FollowupOutstandingContractInformation,
  [TaskCategoryTaskType.FinanceDue]: IconTaskTypes.FollowupMarketingfunds,
  [TaskCategoryTaskType.BuildingAndPestDue]: IconTaskTypes.OwnerBuilder,
  [TaskCategoryTaskType.Unconditional]: IconTaskTypes.Unconditional,
  [TaskCategoryTaskType.InitialDeposit]: IconTaskTypes.Deposit,
  [TaskCategoryTaskType.BalanceDeposit]: IconTaskTypes.Deposit,
  [TaskCategoryTaskType.CreateBuyerContactInCrm]: IconTaskTypes.AwaitingExchange,
}

export const mapTaskTypeToIconType = (
  taskType?: TaskCategoryTaskType,
  fallback: IconTaskType = IconTaskTypes.NewListing
): IconTaskType => taskIconMap[taskType as TaskCategoryTaskType] ?? fallback

export type AssignTaskHandler = (payload: {
  userId?: string
  campaignId?: string
  contractId?: string
  category?: TaskCategory
}) => void

export type ToggleTaskStepsHandler = (payload: {
  stepIds: number[]
  workflowType: TaskCategoryWorkflowType
  category?: TaskCategory
  campaignId?: string
  contractId?: string
}) => void

export type AssigneeOption = SelectChipOption
